import { Label } from "semantic-ui-react"
import Price from "components/Price/Price"
import React from "react"
import OrderModel   from "shop/OrderModel";
import shop from "shop/shop"

let orders = []
let ordersWithOpenPositions = []
let openPositions = []
let boughtPositions = []
let current = 0


const ProductPrice = ( { product, className = "pb4 pt2 relative lh-solid" } ) => {
  let pageSize = 20
  let start = current
  current = current + pageSize
  shop.fetch( `/shop/rest/data/orders?start=${start}&count=${pageSize}&open=0` )
    .then( res => {
      //console.log( "FROM API", { res } )
      orders = orders.concat( res.values.map( data => new OrderModel( data ) ) )
      openPositions = []
      boughtPositions = []
      // find orders with Open Positions
      let orderOpen = orders.filter( order => {
      return order.positions.filter( product => {
        product.lastbought = order.map_id
        product.created = order.created
        boughtPositions.push( product )
        let hasOpen = product.open && product.open !== 0
        if ( hasOpen ) {
        openPositions.push( product )
        }
        return hasOpen
      } ).length
      } )
      
    } )
    //console.log("BOUGHTPOSITIONS: ",boughtPositions)
    let baseUrl = (process.env.BSHOP_BASE_URL || process.env.REACT_APP_API)
    let hasBought = 0
    let created = ''
    let lastboughtArticle = ''
		if(boughtPositions){
			if(boughtPositions.length > 0  && hasBought != 1){
				for(let j = 0; boughtPositions.length > j;j++){
					if(boughtPositions[j].article_nr == product.article_nr && hasBought < boughtPositions[j].lastbought){
						hasBought = boughtPositions[j].lastbought
            lastboughtArticle = boughtPositions[j].lastbought
            created = boughtPositions[j].created.substring(0,boughtPositions[j].created.length-9)
            created = created.substring(8,10) + '.' + created.substring(5,7) + '.' + created.substring(0,4) 
					}
				}
			}
		}
    let articleOpen = 0		
		if(openPositions){
			if(openPositions.length > 0){
				for(let i = 0; openPositions.length > i;i++){
					if(openPositions[i].article_nr == product.article_nr){
						articleOpen = 1
					}
				}
			}
		}
    

  return <div className={`ProductPrice ${className}`}>
    <div className="flex flex-row pb2">
      {product.pinfos.gc_rabatt && <Label className={"giftcardPercent"} color="red">COUPON {product.pinfos.gc_rabatt} %</Label>}
      {/*product.isSale && <Label className={"salePercent"} color="red">{product.salePercent}</Label>*/}
      {product.cats[1] && product.cats[1].cat_id == 'NEU' && <a className="labelNeu3">&nbsp;&nbsp;{translate("Neu!")}&nbsp;&nbsp;</a>}
      {product.cats[0] && product.cats[0].cat_id == 'NEU' && <a className="labelNeu3">&nbsp;&nbsp;{translate("Neu!")}&nbsp;&nbsp;</a>}
      {product.isSale && <a className="labelNeuSale">&nbsp;{Math.round(product.salePercentReal*100)} % Rabatt&nbsp;</a>}
      {product.isSale && <a className="">&nbsp;</a> }
      {product.isSale && product.pinfos.sale_percent && <a className="labelNeu3">&nbsp;&nbsp;{translate("Sale!")}&nbsp;&nbsp;</a>}
      {articleOpen == 1 && <a className="labelZuletztBestelltPrice">&nbsp;&nbsp;{translate("Rückstand")}&nbsp;&nbsp;</a>}
      {articleOpen == 1 && <a className="">&nbsp;</a>}
      {shop.session &&  hasBought != 0 && <a href={ `${baseUrl}/account/orders/${lastboughtArticle}` } className="labelZuletztBestelltPrice">&nbsp;&nbsp;{translate("Zuletzt bestellt am: ")}{created}&nbsp;&nbsp;</a>}
    </div>
    
    {product.isSale && <div>
      {/*<div className="unit_multi black-70 f6 pb2 fw2">Stückpreis</div><br/>*/}
      <div className="f4 red b"><Price>{product.price}</Price> <span className="f5 black-60 fw4 pb1 strike "><Price>{product.pinfos.brutto}</Price></span></div>
      <div className=" black-70 f6 fw2 lh-solid">{product.extras.veextrainfo || translate( "Stückpreis" )}</div>
    </div>}
    
    {!product.isSale &&
    <div className="price  lh-solid  ">
      <div className="f3  b"><Price>{product.price}</Price> {product.salePercent &&
      <span className={"black-60 f5 fw4"}>(<Price>{product.originalPrice}</Price> abzgl. {product.salePercent} Rabatt)</span>}
      </div>
      <div className=" black-70 f6 fw2 lh-solid">{product.extras.veextrainfo || translate( "Stückpreis" )}</div>
    </div>}

  </div>
}

export default ProductPrice


// WEBPACK FOOTER //
// ./src/theme/ortho-test/components/Product/ProductPrice.js